export default __webpack_public_path__ + "static/media/ladyCash2.7d725dd3.jpg";